import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { DynamicScriptLoaderServiceService } from '../../_services/dynamic-script-loader-service.service';
import { AuthenicationService } from '../../_services/authenication.service';
import { DoctorService } from '../../_services/doctor.service';
import { UserService } from '../../_services/user.service';
import { ToasterService } from '../../_services/toaster.service';
import { ExcelServicesService } from "../../_services/excel-services.service";

import {environment} from '../../../environments/environment';
import {FormBuilder, FormGroup, Validators } from '@angular/forms';
import {first} from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $: any;

@Component({
  selector: 'app-applied-mhp',
  templateUrl: './applied-mhp.component.html',
  styleUrls: ['./applied-mhp.component.css']
})
export class AppliedMhpComponent implements OnInit {
  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  submitted = false;
  usersid: string;
  doctorid: string;
  returnUrl: string;
  selectedfile: File = null;
  selectedfile1: Array<File> = [];
  status = false;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  doc = 'application/msword';
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  pdf = 'application/pdf';

  doctors: [];
  therapists: any[] = [];

  isShown: boolean = false ; // hidden by default
  isShown1: boolean = false ; // hidden by default

  issessionmode: any;
  issessionspace: any;
  imgKey: string = environment.imgKey;
  encodedKey: string;
  customerListAllowedUsers: Array<string>;

  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private toaster: ToasterService, private userservice: UserService, private spinnerService: Ng4LoadingSpinnerService, private ng2ImgMax: Ng2ImgMaxService,private excelService:ExcelServicesService) { }

  ngOnInit() {
    this.encodedKey = btoa(this.imgKey);
    this.customerListAllowedUsers = ["abhishek@mindpeerssubadmin.com"];
    // DynamicScriptLoaderServiceService.adminScripts();
   // DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom.js');
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin' || this.userdetaild['users_usertype'] !== 'employee1') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
     DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/selectpicker.js');




    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    let podtData = {status: false};

    this.doctorsList(podtData);
  }

  doctorsList(data) {
    this.doctorservice.getDoctorsByStatus(data)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.doctors = data.doctorsList;

            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Doctor', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }


  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.therapists, 'therapists');
    this.spinnerService.hide();
  }



  toggleShow() {

    this.isShown = ! this.isShown;

  }

  toggleShow1() {

    this.isShown1 = ! this.isShown1;

  }

  updateUserStatus(status, id) {

    const formdata = new FormData();

    formdata.append('id', id);
    formdata.append('status', status);

    this.userservice.changeStatus(formdata)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Status Changed', data.ResponseMessage);

            // let podtData = {status: false};
            // this.doctorsList(podtData);
            $('#ordine').modal('hide');
            this.reloadComponent();
          } else {
            this.toaster.showError('Status Changed', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Status Changed', error.ResponseMessage);
        });
  }

  deleteUser(id, status) {
    if(confirm("Are you sure to delete this MPH")) {
      const formdata = new FormData();

      formdata.append('userid', id);
      formdata.append('isDeleted', status);

      this.doctorservice.deleteUser(formdata)
        .pipe(first())
        .subscribe(
          (data: any) => {
            if (data && data.ResponseCode === '200') {
              // let podtData = {status: false};
              // this.doctorsList(podtData);
              this.reloadComponent();
            } else {
              this.toaster.showError('Status Changed', data.ResponseMessage);
            }

          },
          error => {
            this.toaster.showError('Status Changed', error.ResponseMessage);
          });
  }


  }

  reloadComponent() {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['/applied-mhp']);
  }

  setSpecialDoctors(status, id, type) {

    const formdata = {
      status: status,
      type: type,
      id: id,
    };

    this.doctorservice.setSpecialDoctors(formdata)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Status Changed', data.ResponseMessage);
            // let podtData = {status: false};
            // this.doctorsList(podtData);
            this.reloadComponent();
          } else {
            this.toaster.showError('Status Changed', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Status Changed', error.ResponseMessage);
        });
  }

}
